module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/137P6o0/tc-custom/9781459251915.jpg?1718169669634",
      "alt": "This image is the cover for the book To Woo a Wife, Bachelor Brothers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("To Woo a Wife, Bachelor Brothers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Jarrett, Jonathan and Jordan Hunter are Bachelor Brothers")]), _c('br'), _c('br'), _c('b', [_vm._v("Some men are "), _c('i', [_vm._v("meant")]), _vm._v(" to marry!")]), _c('br'), _c('br'), _c('b', [_vm._v("Jarrett.")]), _vm._v(" The oldest Hunter brotherhe's dark, handsome and impossibly rich. He's never fallen in love, until he meets Abbie Sutherland. He intended to buy out her chain of hotelsand now his prize is "), _c('i', [_vm._v("her")]), _vm._v("."), _c('br'), _c('br'), _vm._v("Abbie is beautiful, sexyutterly desirable. But she is also a young widow wary of emotional and physical involvement. For Jarrett, always a winner in the boardroom "), _c('i', [_vm._v("and")]), _vm._v(" the bedroom, this is the ultimate challenge. Wealth and seduction are not enough for Abbieshe needs to be wooed!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carole Mortimer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carole Mortimer was born in England, the youngest of three children. She began writing in 1978, and has now written over one hundred and seventy books for Harlequin Mills and Boon®. Carole has six sons, Matthew, Joshua, Timothy, Michael, David and Peter. She says, ‘I’m happily married to Peter senior; we’re best friends as well as lovers, which is probably the best recipe for a successful relationship. We live in a lovely part of England.’")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0